import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const works = [
  {
    title: "Kiln & Clay",
    tag: "Ceramics storefront",
    type: "E-commerce",
    img: "https://static.prod-images.emergentagent.com/jobs/3f7ef5a3-e08e-4053-bc90-55479d570c9f/images/7e34e8e471e18d32f1c91cabacb7d4c9c700c03ebf9f2c95295899aa58631122.jpeg",
    alt: "Laptop showing a minimal jade-toned ceramics e-commerce website",
  },
  {
    title: "Marrow",
    tag: "Table bookings",
    type: "Restaurant site",
    img: "https://static.prod-images.emergentagent.com/jobs/3f7ef5a3-e08e-4053-bc90-55479d570c9f/images/4493ae8fc80fb4dddadfafed1babca045b6c6ea25714094312a6f221cd145ae8.jpeg",
    alt: "Laptop showing a clean sage-toned restaurant booking website",
  },
  {
    title: "Loam",
    tag: "Marketing site",
    type: "SaaS",
    img: "https://static.prod-images.emergentagent.com/jobs/3f7ef5a3-e08e-4053-bc90-55479d570c9f/images/d8b6e8cb91edc4eb13043509ea304d491a4777856f74e2321dac8f1f98941c4f.jpeg",
    alt: "Laptop showing a modern SaaS marketing website with jade accents",
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
};

const Portfolio = () => (
  <section id="work" className="relative overflow-hidden py-24 lg:py-32">
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <motion.p
        {...fadeUp}
        transition={{ duration: 0.6 }}
        className="text-xs font-medium uppercase tracking-[0.3em] text-jade"
      >
        Selected work
      </motion.p>
      <motion.h2
        {...fadeUp}
        transition={{ duration: 0.7, delay: 0.08 }}
        className="mt-4 font-display text-3xl font-light leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl"
        data-testid="work-heading"
      >
        Recent <em className="italic text-jade">builds</em>.
      </motion.h2>

      <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
        {works.map((work, i) => (
          <motion.article
            key={work.title}
            {...fadeUp}
            transition={{ duration: 0.7, delay: 0.1 * i }}
            className="group overflow-hidden rounded-2xl bg-white shadow-ambient transition-shadow duration-500 hover:shadow-ambient-lg"
            data-testid={`work-card-${work.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={work.img}
                alt={work.alt}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
              />
            </div>
            <div className="flex items-center justify-between p-7">
              <div>
                <h3 className="font-display text-2xl font-medium text-ink">
                  {work.title}
                </h3>
                <p className="mt-1 text-sm text-ink2/80">{work.tag}</p>
              </div>
              <div className="flex items-center gap-2">
                <span className="rounded-full border border-jade/20 px-3 py-1 text-xs text-jade">
                  {work.type}
                </span>
                <ArrowUpRight className="h-4 w-4 text-jade/60 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </div>
            </div>
          </motion.article>
        ))}
      </div>

      <motion.p
        {...fadeUp}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="mt-8 text-sm italic text-ink2/70"
        data-testid="work-note"
      >
        Sample work shown. Your project could be next.
      </motion.p>
    </div>
  </section>
);

export default Portfolio;